import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../../components/LanguageSwitcher';

const LanguageSelectScreen: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // Traductions pour le bouton OK selon la langue sélectionnée
  const getOkButtonText = () => {
    const translations = {
      'fr': 'Continuer ✨',
      'en': 'Continue ✨',
      'es': 'Continuar ✨',
      'de': 'Weiter ✨',
      'it': 'Continua ✨',
      'pt': 'Continuar ✨',
      'hi': 'जारी रखें ✨',
      'zh': '继续 ✨'
    };
    
    const currentLang = i18n.resolvedLanguage || i18n.language || 'fr';
    return translations[currentLang as keyof typeof translations] || 'Continue ✨';
  };

  const handleContinue = () => {
    // After choosing language, continue to next onboarding step
    navigate('/onboarding/welcome');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000000',
        p: 3,
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 520,
          backgroundColor: '#000000',
          border: '1px solid rgba(241, 192, 134, 0.3)',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
        }}
      >
        <CardContent
          sx={{
            p: { xs: 3, md: 4 },
          }}
        >
          <Typography 
            variant="h5" 
            sx={{ 
              color: '#fff', 
              fontWeight: 'bold', 
              mb: 2,
              textAlign: 'center'
            }}
          >
            🌍 {t('settings.language')}
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgba(255,255,255,0.7)', 
              mb: 3,
              textAlign: 'center'
            }}
          >
            {t('settings.language_desc')}
          </Typography>

          <LanguageSwitcher size="medium" fullWidth />

          <Button
            fullWidth
            variant="contained"
            onClick={handleContinue}
            sx={{
              mt: 3,
              height: '56px',
              borderRadius: '8px',
              backgroundColor: '#f1c086',
              color: '#000',
              fontSize: '1rem',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: '#e0b076',
              },
            }}
          >
            {getOkButtonText()}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LanguageSelectScreen;